import { useContext } from 'react';
import './statics.scss';
import Button from 'components/button';
import { stripHtml } from 'utils/helpers';
import { INE_URL } from 'constants/domains';
import { SessionContext } from 'contexts/session';
import { PLAN_ENTERPRISE_PLUS_LAB, PLAN_LAB_EXPERIENCE } from 'constants/plans_config';
import { INE_CONTACT_SALES } from 'constants/settings';
import {
  CONTACT_SALES_CTA,
  CONTENT_TYPES,
  SKILL_DIVE_LAB,
  SKILL_DIVE_LAB_TYPE,
  STANDARD_LAB_TAG,
} from 'constants/playlists';

export interface IPreviewData {
  objectID: string;
  slug: string;
  description: string;
  lab_type: string;
  flags: [];
  is_lab_experience: boolean;
  metadata: { courses: string[] };
}

interface IPreviewProps {
  data: IPreviewData;
}

const PreviewLab = (props: IPreviewProps): JSX.Element => {
  const {
    objectID,
    slug,
    flags,
    description,
    is_lab_experience,
    lab_type,
    metadata: { courses },
  } = props.data;
  const { account } = useContext(SessionContext);
  const stripDescription = description ? stripHtml(description) : '';

  const has_lab_expericence =
    account?.pricing_plan === PLAN_LAB_EXPERIENCE ||
    account?.pricing_plan === PLAN_ENTERPRISE_PLUS_LAB;

  const has_skill_dive =
    account?.account_available_addons?.filter((ad) => ad.name === CONTENT_TYPES.SKILL_DIVE).length >
    0;

  const handleDetails = () => {
    // @ToDo Get the parent Course and use the Course slug to build the correct URL
    window.open(`${INE_URL}/course/${slug}/${courses[0]}/lab/${objectID}`);
  };

  const handleContact = () => {
    window.location.href = `mailto:${INE_CONTACT_SALES},${account?.sales_contact?.email}`;
  };

  return (
    <div className="preview-tooltip">
      {stripDescription && (
        <p className="preview-tooltip__description">
          <b>Overview: </b>
          {stripDescription.length > 600
            ? stripDescription.slice(0, 600) + '...'
            : stripDescription}
        </p>
      )}

      <div className="preview-tooltip__info-container">
        <div className="preview-tooltip__info-row">
          <div className="preview-tooltip__info-column">LAB TYPE</div>
          <div className="preview-tooltip__info-column">
            {is_lab_experience && lab_type === SKILL_DIVE_LAB_TYPE
              ? SKILL_DIVE_LAB
              : STANDARD_LAB_TAG}
          </div>
        </div>
        <div className="preview-tooltip__info-row">
          <div className="preview-tooltip__info-column">ACTIVITIES</div>
          <div className="preview-tooltip__info-row">
            <div className="preview-tooltip__activity-amount-tag">FLAGS:{flags.length}</div>
          </div>
        </div>
      </div>
      <div className="preview-tooltip__button-container">
        {is_lab_experience && !has_lab_expericence && !has_skill_dive ? (
          <Button icon="Envelope" $secondary size="small" onClick={handleContact}>
            {CONTACT_SALES_CTA}
          </Button>
        ) : (
          <Button
            icon="ExternalLink"
            disabled={!courses || (courses && !courses.length)}
            $secondary
            size="small"
            onClick={handleDetails}
          >
            Preview lab
          </Button>
        )}
      </div>
    </div>
  );
};

export default PreviewLab;
